/*
 * a11y-consent-inert.js
 * Consent tools (Usercentrics, AdRoll) keep hidden controls at tabindex="0" while no banner is showing, which
 * adds invisible Tab stops before "Skip to content" (WCAG 2.4.3 / 2.4.7). This makes the host `inert` while it
 * has no visible banner view, and removes `inert` the moment one appears. A visible banner is never touched.
 */
(function () {
  'use strict';

  // host selector -> selectors that identify a banner "view" inside it (searched in light DOM and open shadow roots)
  var HOSTS = [
    { host: '#usercentrics-cmp-ui', views: '[role="dialog"], [aria-modal="true"], #uc-main-dialog, .cmp-wrapper' },
    { host: '#adroll_consent_container', views: '[role="dialog"], [aria-modal="true"], #adroll_consent_banner' }
  ];
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var lastInteraction = 0;
  var timer = null;

  function isHidden(el, stop) {
    for (var n = el; n && n !== stop; n = n.parentNode instanceof ShadowRoot ? n.parentNode.host : n.parentElement) {
      if (n.nodeType !== 1) break;
      if (n.getAttribute('aria-hidden') === 'true' || n.hidden) return true;
      var cs = getComputedStyle(n);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return true;
    }
    return false;
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.width >= 1 && r.height >= 1 && r.bottom > 0 && r.right > 0 &&
      r.top < (window.innerHeight || document.documentElement.clientHeight) &&
      r.left < (window.innerWidth || document.documentElement.clientWidth);
  }

  function findViews(root, sel, out) {
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) out.push(list[i]);
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) { watch(all[j].shadowRoot); findViews(all[j].shadowRoot, sel, out); }
    }
    return out;
  }

  function hasVisibleView(host, sel) {
    if (host.shadowRoot) watch(host.shadowRoot);
    var roots = [host];
    if (host.shadowRoot) roots.push(host.shadowRoot);
    for (var r = 0; r < roots.length; r++) {
      var views = findViews(roots[r], sel, []);
      for (var i = 0; i < views.length; i++) {
        if (!isHidden(views[i], host.parentNode) && inViewport(views[i])) return true;
      }
    }
    return false;
  }

  function firstFocusable(root) {
    var f = root.querySelector('button:not([disabled]), a[href], [tabindex="0"]');
    return f;
  }

  function evaluate(fromEvent) {
    for (var i = 0; i < HOSTS.length; i++) {
      var host = document.querySelector(HOSTS[i].host);
      if (!host) continue;
      watch(host);
      var visible = hasVisibleView(host, HOSTS[i].views);
      if (visible && host.inert) {
        host.inert = false;
        host.removeAttribute('inert');
        // a banner opened by the user (e.g. "Privacy settings" link) may have tried to take focus while inert
        if ((fromEvent || Date.now() - lastInteraction < 1500) && (!document.activeElement || document.activeElement === document.body)) {
          var scope = host.shadowRoot || host;
          var d = scope.querySelector('[role="dialog"], #uc-main-dialog') || scope;
          var f = firstFocusable(d);
          if (f && f.focus) f.focus();
        }
      } else if (!visible && !host.inert) {
        host.inert = true;
      }
    }
  }

  function schedule(fromEvent) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      evaluate(fromEvent === true);
      // transitions/animations finish without DOM mutations; re-check shortly after
      setTimeout(function () { evaluate(false); }, 400);
    }, 50);
  }

  var mo = typeof MutationObserver === 'function' ? new MutationObserver(function () { schedule(false); }) : null;

  function watch(node) {
    if (!mo || !node) return;
    if (observed) { if (observed.has(node)) return; observed.add(node); }
    mo.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'role', 'aria-modal'] });
  }

  function init() {
    watch(document.body);
    evaluate(false);
    ['UC_UI_VIEW_CHANGED', 'UC_UI_INITIALIZED', 'UC_CONSENT', 'UC_SDK_EVENT'].forEach(function (name) {
      window.addEventListener(name, function () { schedule(name === 'UC_UI_VIEW_CHANGED'); });
    });
    ['click', 'keydown'].forEach(function (name) {
      document.addEventListener(name, function () { lastInteraction = Date.now(); }, true);
    });
    window.addEventListener('resize', function () { schedule(false); });
    // light safety net for consent scripts that load late or change state without events
    setInterval(function () { evaluate(false); }, 1500);
  }

  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();
